// import { Backdrop } from '@mui/material';
// import React, { useContext } from 'react';
// import { Spinner } from 'reactstrap';
// import UIContext from '../Context.js/UIContext';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(theme => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: '#fff',
//     display: 'flex',
//     flexDirection: 'column',
//   },
// }));

// const Loader = () => {
//   const classes = useStyles();
//   const {loader}=useContext(UIContext)

//   return (
//     <Backdrop open={loader} className={classes.backdrop}>
//       <Spinner name="ball-spin-fade-loader" color="#fafafa" />
//     </Backdrop>
//   );
// };

// export default Loader;


import { Backdrop } from '@mui/material';
import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import UIContext from '../Context.js/UIContext';
import './spinner.css'; // 👈 Make sure this path is correct

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const Loader = () => {
  const classes = useStyles();
  const { loader } = useContext(UIContext);

  return (
    <Backdrop open={loader} className={classes.backdrop}>
      <div className="loader3">
        <div className="circle1"></div>
        <div className="circle1"></div>
        <div className="circle1"></div>
        <div className="circle1"></div>
        <div className="circle1"></div>
      </div>
    </Backdrop>
  );
};

export default Loader;

